import React, { useState, useEffect } from "react";
import TakafulDataService from "../services/TakafulService";

const Takaful = props => {
  const initialTakafulState = {
    amount: "",
    previousBalance: "",
    newBalance: ""
  };
  const [currentTakaful, setCurrentTakaful] = useState(initialTakafulState);
  const [message, setMessage] = useState("");

  const getTakaful = id => {
    TakafulDataService.get(id)
      .then(response => {
        setCurrentTakaful(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (props.match?.params?.id) {
      getTakaful(props.match.params.id);
    }
  }, [props.match?.params?.id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentTakaful({ ...currentTakaful, [name]: value });
  };

  const updateTakaful = () => {
    TakafulDataService.update(currentTakaful.id || currentTakaful._id, currentTakaful)
      .then(response => {
        setMessage("Takaful transaction was updated successfully!");
      })
      .catch(e => {
        console.log(e);
      });
  };

  const deleteTakaful = () => {
    TakafulDataService.remove(currentTakaful.id || currentTakaful._id)
      .then(response => {
        if (props.history?.push) {
          props.history.push("/dashboard/takaful");
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  return (
    <div>
      {currentTakaful ? (
        <div className="edit-form">
          <h4>Takaful Transactions</h4>
          <form>
            <div className="form-group">
              <label htmlFor="amount">Amount</label>
              <input
                type="text"
                className="form-control"
                id="amount"
                name="amount"
                value={currentTakaful.amount}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="previousBalance">Previous Balance</label>
              <input
                type="text"
                className="form-control"
                id="previousBalance"
                name="previousBalance"
                value={currentTakaful.previousBalance}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="newBalance">New Balance</label>
              <input
                type="text"
                className="form-control"
                id="newBalance"
                name="newBalance"
                value={currentTakaful.newBalance}
                onChange={handleInputChange}
              />
            </div>
          </form>      

          <button className="badge badge-danger mr-2" onClick={deleteTakaful}>
            Delete
          </button>

          <button
            type="submit"
            className="badge badge-success"
            onClick={updateTakaful}
          >
            Update
          </button>
          <p>{message}</p>
        </div>
      ) : (
        <div>
          <br />
          <p>Please click on Takaful Transaction...</p>
        </div>
      )}
    </div>
  );
};

export default Takaful;
